import React, {useEffect} from 'react'
import {Row, Col, H5, InlineLoader} from '@modifi/ui'
import {useTranslation} from '@modifi/plugin-i18n'
import {
  DIRECT_DEBIT_ACCOUNT_ACCOUNT_NUMBER,
  DIRECT_DEBIT_ACCOUNT_BANK_CODE,
  DIRECT_DEBIT_ACCOUNT_BANK_NAME,
  DIRECT_DEBIT_ACCOUNT_ACCOUNT_HOLDER,
  COMPANY_DIRECT_DEBIT_BANK_DETAILS,
  AddressForm,
  useRenderPersistedObject,
  InputComponent,
  BankAccountNumberInputComponent,
} from '@modifi/plugin-onboarding'

import {FormInputComponentCol} from '../../../../../plugins/onboarding'
import {FormRow} from '../../../../../ui/form'

type DirectDebitAccountProps = {
  initialFormDataLoading?: boolean
  errorMessage?: string | null
  externalErrorMessages: Record<string, string>
  canUpdate?: boolean
}

const DirectDebitAccountFormContent: React.FC<DirectDebitAccountProps> = ({
  initialFormDataLoading = false,
  errorMessage = null,
  externalErrorMessages,
  canUpdate = true,
}) => {
  const {t} = useTranslation('charon')

  useEffect(() => {
    if (errorMessage) window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
  }, [errorMessage])

  const commonInputProps = useRenderPersistedObject({isReadonly: !canUpdate})

  if (initialFormDataLoading) {
    return (
      <Row justifyContent="center">
        <Col auto>
          <InlineLoader />
        </Col>
      </Row>
    )
  }

  return (
    <>
      <Row>
        <FormInputComponentCol
          t={t}
          inputComponent={InputComponent}
          inputName={DIRECT_DEBIT_ACCOUNT_ACCOUNT_HOLDER}
          key={DIRECT_DEBIT_ACCOUNT_ACCOUNT_HOLDER}
          isValid={!externalErrorMessages?.[DIRECT_DEBIT_ACCOUNT_ACCOUNT_HOLDER]}
          errorMessage={externalErrorMessages?.[DIRECT_DEBIT_ACCOUNT_ACCOUNT_HOLDER]}
          inputProps={commonInputProps}
        />
      </Row>
      <Row>
        <Col>
          <H5>{t('direct-debit-account-page.account-holder-address.headline')}</H5>
        </Col>
      </Row>
      <Row mt={8} mb={48}>
        <Col>
          <AddressForm formType={COMPANY_DIRECT_DEBIT_BANK_DETAILS} isReadOnly={!canUpdate} />
        </Col>
      </Row>
      <FormRow>
        <FormInputComponentCol
          t={t}
          inputComponent={InputComponent}
          inputName={DIRECT_DEBIT_ACCOUNT_BANK_NAME}
          key={DIRECT_DEBIT_ACCOUNT_BANK_NAME}
          isValid={!externalErrorMessages[DIRECT_DEBIT_ACCOUNT_BANK_NAME]}
          errorMessage={externalErrorMessages[DIRECT_DEBIT_ACCOUNT_BANK_NAME]}
          inputProps={commonInputProps}
        />
        <FormInputComponentCol
          t={t}
          inputComponent={BankAccountNumberInputComponent}
          inputName={DIRECT_DEBIT_ACCOUNT_ACCOUNT_NUMBER}
          key={DIRECT_DEBIT_ACCOUNT_ACCOUNT_NUMBER}
          isValid={!externalErrorMessages[DIRECT_DEBIT_ACCOUNT_ACCOUNT_NUMBER]}
          errorMessage={externalErrorMessages[DIRECT_DEBIT_ACCOUNT_ACCOUNT_NUMBER]}
          inputProps={commonInputProps}
        />
        <FormInputComponentCol
          t={t}
          inputComponent={BankAccountNumberInputComponent}
          inputName={DIRECT_DEBIT_ACCOUNT_BANK_CODE}
          key={DIRECT_DEBIT_ACCOUNT_BANK_CODE}
          isValid={!externalErrorMessages[DIRECT_DEBIT_ACCOUNT_BANK_CODE]}
          errorMessage={externalErrorMessages[DIRECT_DEBIT_ACCOUNT_BANK_CODE]}
          inputProps={commonInputProps}
        />
      </FormRow>
    </>
  )
}

export default DirectDebitAccountFormContent
